import { render, staticRenderFns } from "./DefectsLegend.vue?vue&type=template&id=b39a84f4&"
import script from "./DefectsLegend.vue?vue&type=script&lang=js&"
export * from "./DefectsLegend.vue?vue&type=script&lang=js&"
import style0 from "./DefectsLegend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b39a84f4')) {
      api.createRecord('b39a84f4', component.options)
    } else {
      api.reload('b39a84f4', component.options)
    }
    module.hot.accept("./DefectsLegend.vue?vue&type=template&id=b39a84f4&", function () {
      api.rerender('b39a84f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/components/DefectsLegend.vue"
export default component.exports